var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerPin0116 = function SvgMarkerPin0116(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC4E00",
    fillRule: "evenodd",
    d: "M8 2a4.667 4.667 0 0 0-4.667 4.667c0 1.261.57 2.452 1.529 3.698.81 1.051 1.846 2.08 2.96 3.184l.178.177.178-.177c1.114-1.104 2.15-2.133 2.96-3.184.96-1.246 1.529-2.437 1.529-3.698A4.667 4.667 0 0 0 8 2M2 6.667a6 6 0 1 1 12 0c0 1.684-.765 3.16-1.805 4.511-.87 1.13-1.983 2.232-3.094 3.335l-.63.625a.667.667 0 0 1-.942 0l-.63-.625c-1.111-1.103-2.224-2.206-3.094-3.335C2.765 9.827 2 8.351 2 6.667m6-1.334A1.333 1.333 0 1 0 8 8a1.333 1.333 0 0 0 0-2.667M5.333 6.667a2.667 2.667 0 1 1 5.334 0 2.667 2.667 0 0 1-5.334 0",
    clipRule: "evenodd"
  })));
};
export default SvgMarkerPin0116;